module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.$route.name + '-page'],
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.$store.state.app.lang,
    staticClass: "layer-1"
  }), _c('the-popup', {
    staticClass: "layer-2"
  }), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.isLoading) ? _c('the-loader', {
    staticClass: "layer-3"
  }) : _vm._e()], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(!_vm.isLoading) ? _c('the-header', {
    staticClass: "layer-4"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 471
// module chunks = 0